import {Component, Input, OnDestroy, OnInit} from "@angular/core";
import {AbstractControl, FormControl, FormGroup} from "@angular/forms";
import {FieldConfig} from "../../../interfaces/field.interface";
import * as _ from 'lodash';
import { Subscription } from "rxjs";

@Component({
    selector: "app-select",
    templateUrl: './select.component.html',
    styles: []
})
export class SelectComponent implements OnInit, OnDestroy {
    m_field: FieldConfig;
    group: FormGroup;
    public hideMe = false;
    unsubs: Array<Subscription> = [];
    options: Array<any>;
    optionValue;
    optionLabel;

    @Input()
    set field(i_field: FieldConfig) {
        this.m_field = i_field;
        if (this.m_field.ignoreMissingValue && _.isUndefined(this.m_field.value)) {
            this.hideMe = true;
        } else {
            this.hideMe = false;
        }
        this.options = i_field.options;
        this.optionValue = i_field.optionValue || '';
        this.optionLabel = i_field.optionLabel || '';
    }

    constructor() {}

    ngOnInit() {
        if (this.m_field.type === 'select' && this.m_field.observable) {
            this.unsubs.push(
                this.m_field.observable.subscribe((i_options) => {
                    if (!i_options) {
                        this.options = [];
                        return;
                    }
                    this.options = i_options.map((v) => ({
                        optionValue: v[this.optionValue],
                        optionsLabel: v[this.optionLabel]
                    }));
                })
            );
        }
    }

    onChangeSelection(e) {
        // if (this.m_field.optionsSelectSub) {
        //     const field = e.value;
        //     Object.values(this.m_field.options).forEach((v: any) => {
        //         if (v.optionsLabel === field) {
        //             const control: AbstractControl = this.group.controls[this.m_field.optionsSelectSub];
        //             control.patchValue(v.optionType);
        //         }
        //     });
        //
        //
        // }
        if (this.m_field.detectChange && this.m_field.callBackEvent) {
            this.m_field.callBackEvent(this.group.value);
        }
    }

    ngOnDestroy() {
        if (this.unsubs.length > 0) {
            this.unsubs.forEach((s) => {
                s.unsubscribe();
            });
        }
    }
}
